<mat-card data-at-vdd-write-error-modal>
  <mat-card-title>{{ 'DIAGNOSTICS.VDD_WRITE_ERROR_MODAL.TITLE' | translate }}</mat-card-title>
  <mat-card-content>
    <div class="flex flex-col justify-center items-center">
      <button
        gtm="onCloseWriteErrorModal"
        gtmCategory="diagnostics"
        class="btn"
        data-at-close-vdd-write-error-modal-btn
        mat-button
        mat-raised-button
        (click)="dialogRef.close()"
        color="primary"
      >
        {{ 'GENERAL.BUTTON.CLOSE' | translate }}
      </button>
    </div>
  </mat-card-content>
</mat-card>
